<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="is-2column"
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
  <BackgroundImage />
  <DocumentLink />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @searchByKeyword="preSearch"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- 表示設定 -->
    <transition name="popup">
      <PCKnowledgeDisplaySetting
        v-if="state.visibleDisplaySettings"
        @closeDisplaySettings="state.visibleDisplaySettings = false"
      />
    </transition>

    <!-- 並び順 -->
    <transition name="popup">
      <PCKnowledgeSearchOrderSetting
        v-if="state.visibleSearchOrderSettings"
        @closeKnowledgeSearchOrderSetting="state.visibleSearchOrderSettings = false"
        @submit="state.visibleSearchOrderSettings = false, clickSearch()"
      />
    </transition>

    <!-- ノートの選択 -->
    <transition name="popup">
      <PCKnowledgeSelectNote
        v-if="state.visibleKnowledgeSelectNote"
        @closeKnowledgeSelectNote="state.visibleKnowledgeSelectNote = false"
      />
    </transition>

    <div id="wrapper">
      <!-- header:start -->
      <PCSearchUI 
        :screenType="'knowledge'"
        :isAlertShown="false"
        :isSearchExecutedAtSameScreen="true"
        @search="clickSearch"
      />
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button"
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn"
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <div id="navi">
          <div class="navigation-title">期間指定</div>
          <div class="date-picker">
            <div class="date-picker-item">
              <p class="txt">開始日</p>
              <PCKnowledgeCalendar
                class="date-picker-input-wrapper"
                :type="'start'"
                @submitCalendar="calendar.inputStartDate"
                />
            </div>
            <div class="date-picker-tilde">~</div>
            <div class="date-picker-item">
              <p class="txt">終了日</p>
              <PCKnowledgeCalendar
                class="date-picker-input-wrapper"
                :type="'end'"
                @submitCalendar="calendar.inputEndDate"
                />
            </div>
          </div>
          <template v-if="knowledge.categories.length > 0">
            <div class="navigation-title">絞り込み</div>
            <nav class="list01 bg-02 pt20 pb20" style="max-height:calc(100vh - 352px);">
              <CheckBoxTree
                :categories="knowledge.categories"
                :checked="knowledge.search.category" 
                :showCount="!!knowledge.search.keyword" 
                @checkSet="checkUpdate"
                />
            </nav>
          </template>
        </div>
        <main class="" id="main">
          <div class="box02 white">
            <div class="box02-hdg">
              <h1 class="box02-hdg-title hdg03">最新ナレッジ</h1>
              <span v-if="countLists" class="box02-hdg-title-sup">{{countLists}}件</span>
              <span v-if="visible.isSearch" @click="clickResetSearchConditions" role="button" class="box02-hdg-title-sup-link">検索条件のクリア</span>
              <div class="box02-hdg-aside">
                <span role="button" class="box02-hdg-aside-menu"
                  @click="state.visibleSearchOrderSettings = true"
                >並び順 - {{ascendigName}}</span>
                <span v-if="visible.isSearch" role="button" class="box02-hdg-aside-menu" 
                  @click="clickSaveSearchConditions"
                >検索条件の保存</span>
                <span role="button" class="box02-hdg-aside-menu"
                  @click="state.visibleDisplaySettings = true"
                >表示設定</span>
              </div>
            </div>
            <div class="box02-body" id="scroll-target"
              @scroll="handleScroll"
              style="height:calc(100vh - 108px);"
              >
              <p v-if="!knowledge.isSearching && (!knowledge.lists || knowledge.lists.length === 0)" class="txt pt32 pb32 pl40 pr40">キーワードに合致する検索結果がありませんでした。<br>検索キーワードを変更して再度検索してください。</p>

              <PCPagenation
                v-if="knowledge.pagenation.count > knowledge.search.per_page"
                :count="knowledge.pagenation.count"
                :per_page="knowledge.search.per_page"
                :currentPage="knowledge.pagenation.currentPage"
                @changePage="clickPageNation"
              />
              <FontawesomeIcon v-if="knowledge.isSearching" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
              <ul v-else class="list-result">
                <li v-for="list in knowledge.lists" :key="list.id" class="list-result-item" :id="'list-item-' + list.id">
                  <div class="list-result-item-main">
                    <div class="list-result-title"><a @click.prevent.stop="clickTitleInList(list.id)" role="button" v-html="list.title"></a></div>
                    <!-- <p v-if="visible.detail" class="list-result-text">{{list.detail}}</p> -->
                    <p v-if="visible.detail" class="list-result-text" v-html="list.detail"></p>
                    <div class="list-result-note">
                      <span v-if="visible.created" class="list-result-sup">{{formatDate(list.created)}}</span>
                      <span v-if="list.note_count > 0 && visible.note" class="list-result-link" @click="clickNote(list.id)">ノート（{{list.note_count}}）</span>
                      <span v-if="visible.category" class="list-result-sup"><span class="category-item">{{list.knowledge_type_name}}</span><span class="category-item" v-html="list.knowledge_category_name"></span></span>
                    </div>
                  </div>
                  <div class="list-result-item-sub">
                    <div class="button">
                      <ButtonViewLater
                        :afterId="list.after_id"
                        :paramId="list.id"
                        :paramKey="'knowledge'"
                        :gaClass="'ga-knowledge-list-view-later'"
                        @onViewLaterChanged="clickViewLater"
                      />
                    </div>
                  </div>
                </li>
              </ul>
              <PCPagenation class="mb40"
                v-if="knowledge.pagenation.count > knowledge.search.per_page"
                :count="knowledge.pagenation.count"
                :per_page="knowledge.search.per_page"
                :currentPage="knowledge.pagenation.currentPage"
                @changePage="clickPageNation"
              />
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import { KnowledgeList } from '@/logic/knowledge/KnowledgeList'

import PCSearchUI from '@/components/pc/partial/PCSearchUI'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCKnowledgeDisplaySetting from '@/components/pc/popup/PCKnowledgeDisplaySetting.vue'
import PCKnowledgeSearchOrderSetting from '@/components/pc/popup/PCKnowledgeSearchOrderSetting.vue'
import PCKnowledgeSelectNote from '@/components/pc/popup/PCKnowledgeSelectNote.vue'
import PCKnowledgeCalendar from '@/components/pc/popup/PCKnowledgeCalendar.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'

import PCPagenation from '@/components/pc/partial/PCPagenation.vue'
import CheckBoxTree from '@/components/pc/partial/CheckBoxTree.vue'

import { isFromAdminSystem } from '@/util/common'

export default defineComponent({
  // beforeRouteLeave (to, from, next) {
  //   // ナレッジ詳細以外への遷移の際にストアをクリアする
  //   if (to.name && to.name.match(/(PC|SP)KnowledgeDetail/) === null) {
  //     store.dispatch('knowledge/resetAllState')
  //   }
  //   next()
  // },
  components: {
    PCSearchUI,
    PCMenu,
    PCKnowledgeDisplaySetting,
    PCKnowledgeSearchOrderSetting,
    PCKnowledgeSelectNote,
    PCKnowledgeCalendar,
    PCBasicToast,
    PCPagenation,
    CheckBoxTree
  },
  setup (props, context) {
    return {
      isFromAdminSystem,
      ...KnowledgeList(props, context) 
    }
  }
})
</script>

<style lang="scss" scoped>
.box02-body {
  overflow: auto;
}

#navi {
  .list01 {
    padding: 10px 0;
  }
  .list01 + .navigation-title {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}
.date-picker {
  display: flex;
  justify-content: center;
  padding: 20px;
  background-color: rgba(0,0,0,.1);
}
.date-picker-item {
  width: calc(50% - 27px);
  .txt {
    color: #fff;
  }
}
.date-picker-tilde {
  align-self: flex-end;
  width: 58px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 1.8rem;
  color: #fff;
}
.list-result {
  &-item {
    padding: 32px 18px 32px 40px;
    &-main {
      width: calc(100% - 68px);
    }
    &-sub {
      width: 48px;
      margin-left: 20px;
      .button {
        top: 0;
        transform: translate3d(0,0,0);
      }
    }
    .category-item:not(:last-child) {
      margin-right: 1em;
    }
  }
}
</style>
